export default {
    company_agency: "Store",
    document: "DNI",
    no_company_agency_found: "No stores found",
    project_name: "Academia Alba",
}